import buildRequest from '../buildRequest';

// Endpoints
import { typesEndpoint } from '../../../common/types';

// Libs
import { axios } from '../../../lib/axios';

// Utils
import { dataResponse, handleError } from '../../../utils';

export const apiCrearContactoComentario = async ({
  nombre,
  correo,
  seguro,
  comentario,
  tokenReCaptcha,
}) => {
  const url = typesEndpoint.contactanos;

  const request = {
    nombre,
    correo,
    seguro,
    comentario,
    tokenReCaptcha: tokenReCaptcha,
  };

  try {
    const { status, data } = await axios.post(url, request, buildRequest());
    return dataResponse({ data: data.data, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
};
